import axios from 'axios';

const API_URL = window.__CRM_API__ || `${window.location.origin}/api`;

export const documentoService = {
  // Obtener lista de tipos de documentos disponibles
  getTipos: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/documentos/tipos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener tipos de documentos:', error);
      throw error;
    }
  },

  // Generar un documento en PDF
  generar: async (data) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/documentos/generar`, data, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob' // Importante para recibir el PDF como blob
      });
      return response.data;
    } catch (error) {
      console.error('Error al generar documento:', error);
      throw error;
    }
  },

  // Descargar el PDF generado
  descargar: (blob, nombreArchivo) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default documentoService;
